import script from "./TabControl.vue?vue&type=script&setup=true&lang=js"
export * from "./TabControl.vue?vue&type=script&setup=true&lang=js"

import "./TabControl.vue?vue&type=style&index=0&id=6beb3187&scoped=true&lang=scss"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6beb3187"]])

export default __exports__